import { render, staticRenderFns } from "./registerMerchant.vue?vue&type=template&id=34007489&scoped=true"
import script from "./registerMerchant.vue?vue&type=script&lang=js"
export * from "./registerMerchant.vue?vue&type=script&lang=js"
import style0 from "./registerMerchant.vue?vue&type=style&index=0&id=34007489&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34007489",
  null
  
)

export default component.exports